const liveApiUrl = process.env.REACT_APP_LIVE_API_URL
import axios from "axios"

export const getStaffTypesApi = async () => {
    try {

        let apiToken = JSON.parse(localStorage.getItem("Token"))
        const headers = {
            "Access-Control-Allow-Origin": "*",
            "Content-Type": "application/json",
            Authorization: apiToken,
            Accept: "application/json",
            "Cache-Control": "no-cache",
        }

        const response = await axios.get(`${liveApiUrl}/api/gatepass/staff-type`, {
            headers,
        })
        return response
    } catch (error) {
        console.error("Error While Getting Gate pass staff type:", error)
        throw error
    }
}


export const getStaffBystaffTypeApi = async (id) => {
    try {

        let apiToken = JSON.parse(localStorage.getItem("Token"))
        const headers = {
            "Access-Control-Allow-Origin": "*",
            "Content-Type": "application/json",
            Authorization: apiToken,
            Accept: "application/json",
            "Cache-Control": "no-cache",
        }

        const response = await axios.get(`${liveApiUrl}/api/gatepass/get-staff?staff_type_id=${id}`, {
            headers,
        })
        return response
    } catch (error) {
        console.error("Error While Getting Gate pass staff By Staff Type:", error)
        throw error
    }
}

export const createGatePassApproverApi = async (payload) => {
    try {

        let apiToken = JSON.parse(localStorage.getItem("Token"))
        const headers = {
            "Access-Control-Allow-Origin": "*",
            "Content-Type": "application/json",
            Authorization: apiToken,
            Accept: "application/json",
            "Cache-Control": "no-cache",
        }

        const response = await axios.post(`${liveApiUrl}/api/gatepass/create-approval`, payload, {
            headers,
        })
        return response
    } catch (error) {
        console.error("Error While Creating Gate Pass Approver:", error)
        throw error
    }
}


export const getAllApprovalStaffApi = async () => {
    try {

        let apiToken = JSON.parse(localStorage.getItem("Token"));

        const headers = {
            "Access-Control-Allow-Origin": "*",
            "Content-Type": "application/json",
            Authorization: apiToken,
            Accept: "application/json",
            "Cache-Control": "no-cache",
        }

        const response = await axios.get(`${liveApiUrl}/api/gatepass/getAll-approval`, {
            headers,
        })
        return response

    } catch (error) {
        console.error("Error While get Gate Pass Approver:", error)
        throw error
    }
}



export const getAllGatePassRequestApi = async () => {
    try {

        let apiToken = JSON.parse(localStorage.getItem("Token"));

        const headers = {
            "Access-Control-Allow-Origin": "*",
            "Content-Type": "application/json",
            Authorization: apiToken,
            Accept: "application/json",
            "Cache-Control": "no-cache",
        }

        const response = await axios.get(`${liveApiUrl}/api/gatepass/get-all-requests`, {
            headers,
        })
        return response

    } catch (error) {
        console.error("Error While get Gate Pass Request:", error)
        throw error
    }
}


export const updateGatePassRequestAPI = async (payload) => {
    try {

        let apiToken = JSON.parse(localStorage.getItem("Token"));

        const headers = {
            "Access-Control-Allow-Origin": "*",
            "Content-Type": "application/json",
            Authorization: apiToken,
            Accept: "application/json",
            "Cache-Control": "no-cache",
        }

        const response = await axios.post(`${liveApiUrl}/api/gatepass/update-gatepass-request`, payload, {
            headers,
        })
        return response

    } catch (error) {
        console.error("Error While Update Gate Pass Request:", error)
        throw error
    }
}




export const updateAdminGatePassRequestApi = async (payload) => {
    try {

        let apiToken = JSON.parse(localStorage.getItem("Token"));

        const headers = {
            "Access-Control-Allow-Origin": "*",
            "Content-Type": "application/json",
            Authorization: apiToken,
            Accept: "application/json",
            "Cache-Control": "no-cache",
        }

        const response = await axios.post(`${liveApiUrl}/api/gatepass/update-gatepass-request-admin`, payload, {
            headers,
        })
        return response

    } catch (error) {
        console.error("Error While Update Gate Pass Request:", error)
        throw error
    }
}



export const getTeacherGatePassReportApi = async () => {
    try {

        let apiToken = JSON.parse(localStorage.getItem("Token"));

        const headers = {
            "Access-Control-Allow-Origin": "*",
            "Content-Type": "application/json",
            Authorization: apiToken,
            Accept: "application/json",
            "Cache-Control": "no-cache",
        }

        const response = await axios.get(`${liveApiUrl}/api/gatepass/teacher-gatepass-report`, {
            headers,
        })
        return response

    } catch (error) {
        console.error("Error While get Gate Pass Request:", error)
        throw error
    }
}


export const createGatePassApprovalAPI = async (payload) => {
    try {

        let apiToken = JSON.parse(localStorage.getItem("Token"));

        const headers = {
            "Access-Control-Allow-Origin": "*",
            "Content-Type": "application/json",
            Authorization: apiToken,
            Accept: "application/json",
            "Cache-Control": "no-cache",
        }

        const response = await axios.post(`${liveApiUrl}/api/gatepass/create-teacher-gatepass`, payload, {
            headers,
        })
        return response

    } catch (error) {
        console.error("Error While create Gate Pass Request:", error)
        throw error
    }
}


export const getGatePassReportAPI = async (payload) => {
    try {

        let apiToken = JSON.parse(localStorage.getItem("Token"));

        const headers = {
            "Access-Control-Allow-Origin": "*",
            "Content-Type": "application/json",
            Authorization: apiToken,
            Accept: "application/json",
            "Cache-Control": "no-cache",
        }

        const response = await axios.post(`${liveApiUrl}/api/gatepass/get-gate-pass-mapping`, payload, {
            headers,
        })
        return response

    } catch (error) {
        console.error("Error While get Gate Pass report:", error)
        throw error
    }
}



export const getAllStaffAPI = async () => {
    try {

        let apiToken = JSON.parse(localStorage.getItem("Token"));

        const headers = {
            "Access-Control-Allow-Origin": "*",
            "Content-Type": "application/json",
            Authorization: apiToken,
            Accept: "application/json",
            "Cache-Control": "no-cache",
        }

        const response = await axios.get(`${liveApiUrl}/api/tscommon/get-all-staff`, {
            headers,
        })
        return response

    } catch (error) {
        console.error("Error While get All Staff:", error)
        throw error
    }
}